import { render, staticRenderFns } from "./GenComments.vue?vue&type=template&id=9eec8b9c&"
import script from "./GenComments.vue?vue&type=script&lang=js&"
export * from "./GenComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports